export default (payload) => ({
  type: 'NEW_CUSTOMER_STATE',
  payload,
});
